import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DialogService } from '../app.dialog-service';

@Component({
	selector: 'app-dialog',
	templateUrl: './dialog.component.html',
	styleUrls: ['./dialog.component.less']
})
export class DialogComponent {

	/**
	 * Title
	 */
	@Input()
	public title?: string | null;

	/**
	 * Content
	 */
	@Input()
	public content?: string | null;

	/**
	 * Constructor
	 */
	constructor(public dialogService: DialogService) {
	}

	/**
	 * Close dialog
	 */
	public closeDialog(): void {
		this.dialogService.closeDialog();
	}
}
